import Repository from "./Repository";

const PAYMENT_RESOURCE = "/create-group-chat";
export default {
  confirmChat(payload) {
    return Repository.post(`${PAYMENT_RESOURCE}`, payload);
  },
};
